module.exports = "<section class=\"app-footer\">\r\n  <div class=\"container-fluid\">\r\n    <span class=\"float-center\">\r\n      <span>Copyright © 2018</span>\r\n    </span>\r\n    <!--<span class=\"float-right\">\r\n      <span>Built with Love <i class=\"material-icons\">favorite_border</i></span>\r\n    </span>-->\r\n  </div>\r\n</section>"


//////////////////
// WEBPACK FOOTER
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/layout/footer/footer.component.html
// module id = ../../../../../src/app/layout/footer/footer.component.html
// module chunks = main